export const ERROR_CODES = [
    'EMAIL_TAKEN',
    'INVALID_CREDENTIALS',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'VALIDATION_FAILED',
    'INVITE_INVALID',
    'INVITE_EXPIRED',
    'INVITE_USED',
    // Delegate invite: the address already belongs to a member of that account.
    'ALREADY_MEMBER',
    // Team management aimed at someone who is not in the account.
    'NOT_A_MEMBER',
    // That address already has an unaccepted invitation waiting.
    'INVITE_PENDING',
    // Voice-agent (ElevenLabs) provider codes.
    'AGENT_NOT_CONFIGURED',
    'AGENT_ALREADY_SYNCED',
    'AGENT_NOT_SYNCED',
    'AGENT_REQUEST_FAILED',
    'FAQ_EMPTY',
    'DOCUMENT_EMPTY',
    'GOOGLE_NOT_CONFIGURED',
    'GOOGLE_OAUTH_FAILED',
    'GOOGLE_INVALID_STATE',
    'GOOGLE_NOT_CONNECTED',
    // Healee/Superdoc Scheduling provider codes.
    'HEALEE_NOT_CONFIGURED',
    'HEALEE_REQUEST_FAILED',
    'HEALEE_NOT_CONNECTED',
    // In-app assistant (Claude) codes.
    'ASSISTANT_NOT_CONFIGURED',
    'ASSISTANT_REQUEST_FAILED',
    // Onboarding (§3-А). The wizard cannot skip a mandatory step, and cannot be
    // finished before the line can actually receive a call.
    'ONBOARDING_STEP_REQUIRED',
    'ONBOARDING_NUMBER_REQUIRED',
    'ONBOARDING_FORWARDING_REQUIRED',
    'ONBOARDING_NOT_STARTED',
    // Admin phone-number pool. Assign failed because the number is not in the pool
    // (already assigned / released), the target user owns no account, or that
    // account already has an active number.
    'NUMBER_NOT_AVAILABLE',
    'USER_HAS_NO_ACCOUNT',
    'ACCOUNT_HAS_NUMBER',
    'UNKNOWN_ERROR',
];
/** Wire-level separator embedded in `.message` so the client can split a code
 *  from human-readable detail without a custom response shape. ZenStack RPC
 *  only forwards `Error.message`; carrying both code and detail in one string
 *  lets us surface upstream errors (e.g. the provider's rejection reason) in the UI
 *  without server middleware. */
export const CODED_ERROR_DETAIL_SEP = ' :: ';
export class CodedError extends Error {
    code;
    statusCode;
    detail;
    meta;
    constructor(code, statusCode = 400, meta, detail) {
        super(detail ? `${code}${CODED_ERROR_DETAIL_SEP}${detail}` : code);
        this.name = 'CodedError';
        this.code = code;
        this.statusCode = statusCode;
        this.meta = meta;
        this.detail = detail;
    }
}
export function isCodedErrorBody(value) {
    if (!value || typeof value !== 'object')
        return false;
    const code = value.code;
    return typeof code === 'string' && ERROR_CODES.includes(code);
}
